import { QuestionnaireQuestionImage } from "@repo/api";
import DOMPurify from "dompurify";
import { FC, useMemo } from "react";
import * as Styled from "./QuestionnairePage.styled";

export const QuestionnaireQuestionImageComponent: FC<{
    image?: QuestionnaireQuestionImage;
}> = ({ image }) => {
    const clean = useMemo(() => {
        if (!image?.legend) return "";
        return DOMPurify.sanitize(image.legend, {
            ALLOWED_TAGS: ["strong", "h3", "p", "br"],
            ALLOWED_ATTR: ["style"],
        });
    }, [image?.legend]);

    if (!image) return null;

    return (
        <Styled.QuestionnaireQuestionImageStack>
            <Styled.QuestionnaireQuestionImage src={image.base64} />
            <Styled.QuestionnaireQuestionBodyTextXS dangerouslySetInnerHTML={{ __html: clean }} />
        </Styled.QuestionnaireQuestionImageStack>
    );
};
